import { useDispatch, useSelector } from "react-redux";
import { downloadWeeklyDateExcel } from "../thunks/downloadWeeklyDateReportExcel";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useWeeklyDateExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.weeklyTrade.downloadReportFetchState
  );

  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadWeeklyDateExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
